var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"flex-shrink-0 bg-white overflow-hidden object-contain rounded-full",class:[_vm.size],attrs:{"src":_vm.src,"loading":_vm.lazy ? 'lazy' : 'eager'}})
}
var staticRenderFns = []

export { render, staticRenderFns }